import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { getExperienceAddToCalendarMode } from '@/features/experiences/lib/interactivity/getExperienceAddToCalendarMode';
import {
  AddToCalendarConfigMode,
  BannerOptions,
  LogoOptions,
} from '@/types/gql.generated';
import { experiencesWithNoBulkAdd } from '../hack';

export const useHeaderConfig = () => {
  const { experience, readOnly } = usePageExperienceContext();
  const addToCalendarMode = getExperienceAddToCalendarMode(experience);
  const isMagicBarEnabled = addToCalendarMode === AddToCalendarConfigMode.Magic;
  const bulkAddEnabled =
    addToCalendarMode === AddToCalendarConfigMode.EmailInvite &&
    !experiencesWithNoBulkAdd.includes(experience.id);

  const headerEnabled = experience?.bannerDisplay === BannerOptions.Ratio_7_2;
  const logoEnabled = readOnly
    ? Boolean(experience?.logoImageUrl) &&
      experience?.logoDisplay === LogoOptions.Square
    : experience?.logoDisplay === LogoOptions.Square;

  return {
    bulkAddEnabled,
    headerEnabled,
    logoEnabled,
    isMagicBarEnabled,
  };
};
